import { React, useRef, useEffect } from "react";
import { INTERNAL_TRANSLATIONS } from "../../../utils/constant.utils";

import Header from "../../common/header-navigation/header/header.component";
import NavMainMenu from "../../common/nav-menu/nav-main-menu.component";

var navMenu = [
  {
    title: "dashboard",
    href: "/internal",
    ShowNav:true,
  },
  {
    title: "administration",
    href: "#",
    ShowNav:true,
    subMenu: [
      {
        subName: "manage_user_access",
        href: "/internal/Manage-User-Access",
        isActive: true,
      },
      {
        subName: "manage_users",
        href: "/internal/Manage-User",
      },
      {
        subName: "manage_vendors",
        href: "/internal/Manage-Vendor",        
      },
      {
        subName: "manage_cost_codes",
        href: "/internal/Manage-Cost-Codes",        
      },
      {
        subName: "manage_location",
        href: "/internal/Manage-Location",        
      },
      {
        subName: "manage_csat_survey",
        href: "/internal/Manage-CSAT-Survey",        
      },
      
    ],
  },
  {
    title: "order",
    href: "/internal/Orders",
    ShowNav:true,   
  },
  {
    title: "invoice",
    href: "#",
    ShowNav:true,
    subMenu: [
      {
        subName: "invoice",
        href: "/internal/Invoice",       
      },
      {
        subName: "invoice_upload",
        href: "/internal/Invoice/Upload",        
      },
      {
        subName: "charge_mapping",
        href: "/internal/Invoice/ChargeMapping",        
      },
      {
        subName: "invoice_calendar",
        href: "/internal/Invoice/Calendar",        
      },
      
    ],
  }, {
    title: "reports",
    href: "/internal/Reports/Order", 
    ShowNav:true, 
  }, {
    title: "finance",
    href: "#",  
    ShowNav:true,
    subMenu: [
      {
        subName: "contract",
        href: "/internal/Finance/Contract",       
      },
      {
        subName: "catalogue",
        href: "/internal/Finance/Catalogue",        
      },
      {
        subName: "account",
        href: "/internal/Finance/Account",        
      },
      {
        subName: "dispute",
        href: "/internal/Finance/Dispute",        
      },
      {
        subName: "rate_catalogue",
        href: "/internal/Finance/Rate-Catalogue",        
      },
      {
        subName: "cost_center",
        href: "/internal/Finance/Cost-Code",        
      },
      {
        subName: "currency",
        href: "/internal/Finance/Currency",        
      },
      
    ], 
  },{
    title: "inventory_manager",
    href: "/internal/Inventory", 
    ShowNav:true,  
  },
];

function NavMenu() {
const showNotif=false;

  const navMenuRef = useRef(null);

  useEffect(() => {
      const checkIfClickedOutside = (e) => {
      if (navMenuRef.current && !navMenuRef.current.contains(e.target)) {
          var mainNav = document.querySelectorAll(".isActive");
          for (let i = 0; mainNav.length > i; i++) {
          mainNav[i].classList.remove("isActive");
          }
      }
      };

      document.addEventListener("mousedown", checkIfClickedOutside);

      return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
      };
  });

  return (
      <nav className="external-nav" ref={navMenuRef}>
      <Header />
      <NavMainMenu showNotif={false}  navMenu={navMenu} />
    </nav>
  );
}

export default NavMenu;
